import React, { useState } from "react";
import { Card, CardBody, CardHeader, CardGroup } from "../card/card";
import CONFIG from "../../config/config";
import "./emojis-card.css";
import { getAuthHeaders } from "../../misc.js";

const EmojisCard = ({ label, emojis, onEmojisChange, name, onNameChange }) => {
  const [loadingStates, setLoadingStates] = useState({});
  const [errorStates, setErrorStates] = useState({});

  const handlePromptChange = (index, newPrompt) => {
    const updatedEmojis = [...emojis];
    updatedEmojis[index] = { ...updatedEmojis[index], prompt: newPrompt };
    onEmojisChange(updatedEmojis);
  };

  const handleGenerateEmoji = async (index) => {
    setLoadingStates((prev) => ({ ...prev, [index]: true }));
    setErrorStates((prev) => ({ ...prev, [index]: null }));

    try {
      const response = await fetch(`${CONFIG.API_URL}/generate/emoji`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeaders(),
        },
        body: JSON.stringify({
          prompt: emojis[index].prompt,
          dimensions: { width: 512, height: 512 },
          timeout: 300000,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to generate AI emoji");
      }

      const data = await response.json();
      let images = data.images;
      if (Array.isArray(images) && images.length > 0 && Array.isArray(images[0])) {
        images = images.flat();
      }
      if (images && images.length > 0) {
        const updatedEmojis = [...emojis];
        updatedEmojis[index] = {
          ...updatedEmojis[index],
          image: images[0].preview || images[0].image || images[0],
        };
        onEmojisChange(updatedEmojis);
      }
    } catch (error) {
      console.error("Error generating AI emoji:", error);
      setErrorStates((prev) => ({
        ...prev,
        [index]: "Failed to generate AI emoji. Please try again.",
      }));
    } finally {
      setLoadingStates((prev) => ({ ...prev, [index]: false }));
    }
  };

  return (
    <Card>
      <CardHeader>
        <h5>{label}</h5>
      </CardHeader>
      <CardBody>
        <Card className="mb-3">
          <CardHeader>
            <label className="form-label">Correct Answer</label>
          </CardHeader>
          <CardBody>
            <input
              type="text"
              className="form-control"
              value={name}
              onChange={(e) => onNameChange(e.target.value)}
              placeholder="Enter Name"
            />
          </CardBody>
        </Card>

        <CardGroup>
          {emojis.map((emoji, index) => (
            <Card key={index} className="row mb-3">
                <CardHeader className="mb-2">
                  <label className="form-label">Prompt</label>
                </CardHeader>
                <CardBody>
                  <input
                    type="text"
                    className="form-control"
                    value={emoji.prompt}
                    onChange={(e) => handlePromptChange(index, e.target.value)}
                    placeholder='Enter emoji prompt (e.g., "emoji style ... high definition quality and details, white background")'
                  />
                    <button
                      className="btn btn-success w-100 mt-2"
                      onClick={() => handleGenerateEmoji(index)}
                      disabled={loadingStates[index]}
                    >
                      {loadingStates[index] ? "Generating..." : "Generate AI"}
                    </button>
                    {errorStates[index] && (
                      <div className="alert alert-danger mt-2">
                        {errorStates[index]}
                      </div>
                    )}

                  <div className="d-flex align-items-center justify-content-center mt-2">
                    {emoji.image ? (
                      <img
                        src={emoji.image}
                        alt="emoji preview"
                        className="img-fluid"
                      />
                    ) : (
                      <p className="text-muted">No image generated</p>
                    )}
                  </div>
                </CardBody> 
            </Card>
          ))}
        </CardGroup>
      </CardBody>
    </Card>
  );
};

export default EmojisCard;
